let announcer: HTMLElement | null = null;

export function initAnnouncer(): void {
  if (announcer) return;
  announcer = document.createElement('div');
  announcer.setAttribute('role', 'status');
  announcer.setAttribute('aria-live', 'polite');
  announcer.setAttribute('aria-atomic', 'true');
  announcer.style.position = 'absolute';
  announcer.style.width = '1px';
  announcer.style.height = '1px';
  announcer.style.overflow = 'hidden';
  announcer.style.clip = 'rect(0,0,0,0)';
  announcer.style.whiteSpace = 'nowrap';
  document.body.appendChild(announcer);
}

export function announce(message: string, priority: 'polite' | 'assertive' = 'polite'): void {
  if (!announcer) initAnnouncer();
  if (!announcer) return;
  announcer.setAttribute('aria-live', priority);
  // Clear then set to force screen reader to re-read
  announcer.textContent = '';
  requestAnimationFrame(() => {
    if (announcer) announcer.textContent = message;
  });
}
